import {
  BOARD_NOT_FOUND,
  BOARD_PAGE_NOT_FOUND,
  RECEIVE_ITEMS,
  RECEIVE_SIMILAR_ITEMS,
  DELETE_ITEM,
  GOOGLE_ADVERT_LOADED,
  LOADING_DATA_ON_PAGE_LOAD,
  LOADING_DATA_ON_PAGE_LOAD_SIMILAR_ITEMS,
  ITEM_TO_BAG,
  UPDATE_ITEM_INTENT,
  INITIALISED,
  RECEIVE_BOARD_DETAILS,
  RECEIVE_BOARD_SHARE_ID,
  RECEIVE_USER_IDENTITY,
  SET_ITEM_SAVED_STATUS,
  SET_ITEMS_TYPE,
  SET_INITIAL_SORT,
  SHOW_FULFILMENT_INFO,
  SORT_INTENT
} from "./constants";

import {
  RECEIVE_BACK_IN_STOCK_VARIANTS,
  UPDATE_BACK_IN_STOCK_VARIANTS
} from "../../backInStock/constants";
import isBackInStockNotificationEnabled from "../../backInStock/isBackInStockEnabled";

import {
  receiveBoardDetails,
  receiveBoardShareId,
  receiveItems,
  receiveSimilarItems,
  receiveUserIdentity,
  loadingDataOnPageLoad,
  deleteItem,
  updateItem,
  itemToBag,
  setItemsType,
  boardNotFound,
  boardPageNotFound,
  receiveBackInStockVariants,
  updateBackInStockVariants,
  saveForLater,
  setSortIntent,
  setSort,
  showFulfilmentInfo,
  initialised,
  initialisedForBackInStock,
  googleAdvertLoaded
} from "./eventHandlers";

import getUpdateItemEvents from "./eventHandlers/updateItem/getEvents";
import getUpdateItemForBackInStockEvent from "./eventHandlers/updateItemForBackInStock/getUpdateItemEvent";

let reducerMap = {
  [DELETE_ITEM]: deleteItem,
  [GOOGLE_ADVERT_LOADED]: googleAdvertLoaded,
  [ITEM_TO_BAG]: itemToBag,
  [BOARD_NOT_FOUND]: boardNotFound,
  [BOARD_PAGE_NOT_FOUND]: boardPageNotFound,
  [LOADING_DATA_ON_PAGE_LOAD]: loadingDataOnPageLoad,
  [LOADING_DATA_ON_PAGE_LOAD_SIMILAR_ITEMS]: loadingDataOnPageLoad,
  [RECEIVE_BOARD_DETAILS]: receiveBoardDetails,
  [RECEIVE_BOARD_SHARE_ID]: receiveBoardShareId,
  [RECEIVE_ITEMS]: receiveItems,
  [RECEIVE_SIMILAR_ITEMS]: receiveSimilarItems,
  [RECEIVE_USER_IDENTITY]: receiveUserIdentity,
  [SET_ITEM_SAVED_STATUS]: saveForLater,
  [SET_ITEMS_TYPE]: setItemsType,
  [SET_INITIAL_SORT]: setSort,
  [SORT_INTENT]: setSortIntent,
  [SHOW_FULFILMENT_INFO]: showFulfilmentInfo
};

if (isBackInStockNotificationEnabled()) {
  const getEvents = payload => [
    ...getUpdateItemEvents(payload),
    ...getUpdateItemForBackInStockEvent(payload)
  ];

  reducerMap = {
    ...reducerMap,
    [UPDATE_ITEM_INTENT]: updateItem.bind(null, getEvents),
    [UPDATE_BACK_IN_STOCK_VARIANTS]: updateBackInStockVariants,
    [RECEIVE_BACK_IN_STOCK_VARIANTS]: receiveBackInStockVariants,
    [INITIALISED]: initialisedForBackInStock
  };
} else {
  reducerMap = {
    ...reducerMap,
    [UPDATE_ITEM_INTENT]: updateItem.bind(null, getUpdateItemEvents),
    [INITIALISED]: initialised
  };
}

export default reducerMap;
